module.exports = __webpack_public_path__ + "static/media/monc.23ab5362.jpeg";